import { Card, CardContent } from "..";
import { getConfigValue } from "@rumble-it/common-lib/src/config";
import { Button } from "antd";
import clsx from "clsx";
import RumbleQrCode from "./RumbleQrCode";

interface RumbleImageCapturePendingProps {
  imageCapturePending: boolean;
  imageCaptureLink: string;
  cdnUrl?: string;
  title?: string;
  message?: string;
  cardClassname?: string;
  showQrCode?: boolean;
}

export const RumbleImageCapturePending: React.FC<
  RumbleImageCapturePendingProps
> = ({
  imageCapturePending,
  imageCaptureLink,
  title,
  message,
  cardClassname,
  cdnUrl = getConfigValue("cdnUrl"),
  showQrCode = false,
}) => {
  if (!imageCapturePending) return null;

  return (
    <>
      <div>
        <Card
          className={clsx(
            "max-w-4xl w-full bg-[linear-gradient(to_bottom,_rgba(59,130,246,0.2)_0%,_rgba(255,255,255,1)_15%)] text-gray-800 mt-16",
            cardClassname,
          )}
        >
          <CardContent className="py-7 flex flex-col">
            <div className="flex items-center justify-center">
              <div className="w-80 h-auto -my-72">
                <img
                  src={`${cdnUrl}/static/dealer-intake/image-capture.svg`}
                  alt="Afbeelding uploaden"
                />
              </div>
            </div>

            <div className="mt-24">
              <h2 className="text-lg font-semibold mb-4">
                {title ?? "Afbeeldingen uploaden"}
              </h2>

              {showQrCode === true && imageCaptureLink ? (
                <RumbleQrCode
                  url={imageCaptureLink}
                  className="mb-4 float-right ml-4"
                />
              ) : null}

              <p className="mb-4">
                {message
                  ? message
                  : `Na het bevestigen van de herstelafspraak krijg je de
                mogelijkheid om foto's te maken of selecteren van de schade en
                up te loaden naar het systeem. Deze foto's zijn van belang voor
                de hersteller. Zonder deze foto's kan de hersteller
                geen goed beeld krijgen van de schade en is men voorbereid op de
                te verrichten werkzaamheden. Start nu met uploaden van de
                afbeeldingen.`}
              </p>
            </div>

            <span className="flex items-center justify-center">
              <Button type="primary" href={imageCaptureLink} target="_blank">
                Afbeeldingen uploaden
              </Button>
            </span>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default RumbleImageCapturePending;
